// @ts-nocheck
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { Rocket, ArrowLeft } from 'lucide-react';
import PublicHeader from '../components/PublicHeader';
import Footer from '../components/Footer';

interface ComingSoonProps {
  title: string;
  description?: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({ title, description }) => {
  const { isDark } = useTheme();
  const navigate = useNavigate();

  return (
    <div className={`min-h-screen flex flex-col ${
      isDark ? 'bg-zinc-950' : 'bg-gray-50'
    }`}>
      {/* Header */}
      <PublicHeader />

      <div className="flex-1 flex items-center justify-center px-4">
        <div className="max-w-2xl w-full text-center">
        {/* Icon */}
        <div className={`inline-flex items-center justify-center w-24 h-24 rounded-full mb-8 ${
          isDark ? 'bg-blue-500/10' : 'bg-blue-50'
        }`}>
          <Rocket className={`w-12 h-12 ${
            isDark ? 'text-blue-400' : 'text-blue-600'
          }`} />
        </div>

        {/* Title */}
        <h1 className={`text-4xl md:text-5xl font-bold mb-4 ${
          isDark ? 'text-white' : 'text-gray-900'
        }`}>
          {title}
        </h1>

        {/* Coming Soon Badge */}
        <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6 ${
          isDark
            ? 'bg-gradient-to-r from-blue-500/20 to-purple-500/20 border border-blue-500/30'
            : 'bg-gradient-to-r from-blue-50 to-purple-50 border border-blue-200'
        }`}>
          <span className={`text-sm font-semibold ${
            isDark ? 'text-blue-400' : 'text-blue-600'
          }`}>
            Coming Soon
          </span>
        </div>

        {/* Description */}
        <p className={`text-lg mb-8 max-w-xl mx-auto ${
          isDark ? 'text-zinc-400' : 'text-gray-600'
        }`}>
          {description || `We're working hard to bring you this feature. Stay tuned for updates!`}
        </p>

        {/* CTA */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => navigate('/agent-analysis')}
            className={`inline-flex items-center gap-2 px-6 py-3 rounded-xl font-medium transition-all duration-200 ${
              isDark
                ? 'bg-blue-600 hover:bg-blue-700 text-white'
                : 'bg-blue-600 hover:bg-blue-700 text-white'
            }`}
          >
            <ArrowLeft className="w-4 h-4" />
            Back to AI Agents
          </button>

          <button
            onClick={() => navigate('/overview')}
            className={`inline-flex items-center gap-2 px-6 py-3 rounded-xl font-medium transition-all duration-200 ${
              isDark
                ? 'border border-white/10 hover:bg-white/5 text-white'
                : 'border border-gray-200 hover:bg-gray-50 text-gray-900'
            }`}
          >
            View Market Overview
          </button>
        </div>

        {/* Footer Note */}
        <p className={`mt-12 text-sm ${
          isDark ? 'text-zinc-500' : 'text-gray-500'
        }`}>
          Want to be notified when this launches? Follow us on social media for updates.
        </p>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ComingSoon;
